import script from "./testReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./testReport.vue?vue&type=script&lang=ts&setup=true"

import "./testReport.vue?vue&type=style&index=0&id=f94a3060&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f94a3060"]])

export default __exports__